import { Button, Container, makeStyles, Grid } from "@material-ui/core";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { PurchaseFlowContext } from "../../../../contexts/PurchaseFlow";
import { AnimatedText } from "../../../partials/AnimatedText";
import { Flow, NewFlow, RegisterStep } from "../../../PurchaseFlow";
import Cookies from "js-cookie";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-80px",
    height: "auto",
  },
  ContainerPadding: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    // backgroundColor: "yellow",
    [theme.breakpoints.down("xl")]: {
      paddingRight: theme.spacing(0),
      paddingLeft: theme.spacing(0),
      height: "720px",
    },
    [theme.breakpoints.down("lg")]: {
      paddingRight: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      height: "620px",
    },
    [theme.breakpoints.down("md")]: {
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
      height: "500px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      height: "400px",
    },
  },

  jumbo: {
    color: "#fa225e",
    fontSize: "140px",
    fontWeight: 700,
    display: "flex",
    flexWrap: "wrap",
    letterSpacing: "-2px",
    lineHeight: 1,
    marginBottom: "8px",
    [theme.breakpoints.down("lg")]: {
      fontSize: "120px",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "100px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "60px",
    },
    [theme.breakpoints.down(350)]: {
      fontSize: "40px",
    },
  },
  jumboOutlined: {
    color: "transparent",
    "-webkit-text-stroke-width": "2px",
    "-webkit-text-stroke-color": theme.palette.primary.main,

    [theme.breakpoints.down("sm")]: {
      "-webkit-text-stroke-width": "1.5px",
      letterSpacing: 0,
    },
  },
  subtitleText: {
    fontSize: "24px",
    fontWeight: 700,
    paddingLeft: "1px",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      lineHeight: "28px",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.down(350)]: {
      fontSize: "14px",
    },
  },
  getKvixButton: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
    },
  },
}));

export const WelcomeTitle: React.FC = (props) => {
  const classes = useStyles(props);
  const { t, ready } = useTranslation("startPage");
  const { actions } = useContext(PurchaseFlowContext);
  const history = useHistory();

  if (!ready) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Container className={classes.ContainerPadding} maxWidth="lg">
        {/* <div className={classes.textContainer}> */}
        <div className={`${classes.jumbo} ${classes.jumboOutlined}`}>
          <AnimatedText scrollY={{ input: [0, 460], output: [0, -120] }}>
            {t("hero.title.train")}
          </AnimatedText>

          <AnimatedText scrollY={{ input: [0, 460], output: [0, -120] }}>
            {t("hero.title.live")}
          </AnimatedText>
        </div>
        <div className={classes.jumbo}>
          <AnimatedText scrollY={{ input: [0, 460], output: [0, -100] }}>
            {t("hero.title.atHome")}
          </AnimatedText>

          <AnimatedText scrollY={{ input: [0, 460], output: [0, -80] }}>
            {t("hero.title.with")}
          </AnimatedText>

          <AnimatedText scrollY={{ input: [0, 460], output: [0, -80] }}>
            {t("hero.title.us")}
          </AnimatedText>
        </div>
        <div className={classes.subtitleText}>
          <AnimatedText scrollY={{ input: [0, 460], output: [0, -60] }}>
            {t("hero.title.text")}
          </AnimatedText>
        </div>
        <AnimatedText fadeIn={{ fadeTension: 20, fadeDelay: 0 }}>
          <Button
            variant="contained"
            color="primary"
            className={classes.getKvixButton}
            style={{ height: "52px", borderRadius: "26px" }}
            onClick={() => {
              const wpCampaignParams = Cookies.get('wp-campaign');

              if (wpCampaignParams) {
                history.replace(`${history.location.pathname}${wpCampaignParams}`);
              }

              actions.prompt(
                <NewFlow registerProps={{ checkoutSource: wpCampaignParams ? 'wp' : 'kvix' }} currentTab={0} />
              )
            }}
          >
            {t("getKvix")}
          </Button>
        </AnimatedText>
        {/* </div> */}
      </Container>
    </div>
  );
};
